import React from "react";
import "./Header.css";
import { useOptionContext } from "../context/OptionContext";
import { Province } from "../types/canvasTypes";
import Logo from "../assets/logo.png";
import LogoEnglish from "../assets/logoON.png";
import { Link } from "react-router-dom";

import { useCurrentUser } from "../context/UserContext";
import { t } from "i18next";

const Header: React.FC = () => {
  const { province } = useOptionContext();
  const { currentUser, signIn } = useCurrentUser();
  return (
    <nav className="navbar">
      <ul>
        <li>
          <Link className="navbar-logo" to="/" style={{ alignSelf: "center" }}>
            <img
              src={province === Province.Ontario ? LogoEnglish : Logo}
              alt="logo"
              height={80}
              style={{
                mixBlendMode: "multiply",
                objectFit: "cover",
                padding: "10px",
                backgroundColor: "transparent",
                backgroundClip: "content-box",
              }}
            />
          </Link>
        </li>
        {province === Province.Quebec && (
          <h1
            style={{
              cursor: "pointer",
            }}
          >
            <a
              href="https://cloture-verre.com/"
              target="_blank"
              rel="noreferrer"
            >
              cloture-verre.com
            </a>
          </h1>
        )}
        <div style={{ display: "inherit" }}>
          {currentUser?.photoURL && (
            <li>
              <img
                src={currentUser.photoURL}
                alt="user"
                height={40}
                style={{
                  borderRadius: "20%",
                  marginRight: "10px",
                }}
              />
            </li>
          )}
          {currentUser?.displayName && (
            <li style={{ marginRight: "20px" }}>
              Hi {currentUser.displayName}
            </li>
          )}
          {!currentUser && (
            <button className="nav-login-button" onClick={() => signIn()}>
              Google Login
            </button>
          )}

          <li>
            <a href={t("aboutWebsite")} target="_blank" rel="noreferrer">
              {t("about")}
            </a>
          </li>
          <li>
            <a href={t("contactWebsite")} target="_blank" rel="noreferrer">
              {t("contact")}
            </a>
          </li>
        </div>
      </ul>
    </nav>
  );
};

export default Header;
